const getSelectedOptionId = (optionData, optionTypeId) =>
  optionData?.selectedOptions?.[optionTypeId] || null;

export default getSelectedOptionId;
